
import get from 'lodash/get'

export default function(properties) {
  const attributes = {}
  const animation = get(properties, 'base.entranceAnimation')

  if(animation) {
    attributes['data-entrance-animation'] = animation
  }

  return attributes 
}